
var logger = require('../../logger/logger');
var loggerUtils = require('../../logger/utils');
var saleCommonUtility = require('./saleCommonUtility');
var salesChannel = require('../../messaging/sales/salesChannel');



export function publishSaleInChannel(sale)
{
    if (saleCommonUtility.isSaleHold(sale))
    {
        logger.info("Since sale is of type hold, not publishing the message to sale channel");
        return;
    }

    logger.info("Publishing a message to sale channel for sale");
        
    var saleForPublishing = JSON.parse(JSON.stringify(sale));
    
    var messagePayload = {};
    messagePayload.type = "sale";
    messagePayload.sale = saleForPublishing;
    messagePayload.tracingContext = loggerUtils.createTracingContext("sales.channel", "sale.publishing");
    messagePayload.tracingContext.originOrderNumber = saleForPublishing.number;
    messagePayload.tracingContext.originOrderVenue = saleForPublishing.venueCode;
    messagePayload.tracingContext.originOrderDispatchType = saleForPublishing.dispatchType;

    salesChannel.publishMessage(messagePayload);
}